module.exports = __webpack_public_path__ + "img/DTIOB.b52b4d45.png";